import { all } from 'redux-saga/effects'

import messagesListSaga from 'components/Windows/CentralMessagesList/saga'
import restoreBookingSaga from 'pages/PaymentFailed/saga'
import downloadSaga from 'services/downloadFiles/saga'
import sendSmsSaga from 'services/sendSms/saga'
import basketSaga from '../components/Basket/saga'
import changePasswordSaga from '../components/Forms/FormChangePassword/saga'
import contactInfoSaga from '../components/Forms/FormContactInfo/saga'
import lostCardSaga from '../components/Forms/FormLostCard/saga'
import registerClubSaga from '../components/Forms/FormRegisterClub/saga'
import changeForgottenPasswordSaga from '../pages/ChangeForgottenPassword/saga'
import forgottenPasswordSaga from '../pages/ForgottenPassword/saga'
import hallSeatingSaga from '../pages/Hall/components/HallSeating/saga'
import hallSaga from '../pages/Hall/saga'
import loginSaga from '../pages/Login/saga'
import orderSummarySaga from '../pages/OrderSummary/saga'
import paymentVerifySaga from '../pages/PaymentVerify/saga'
import registerSaga from '../pages/Register/saga'
import cinestarClubSaga from '../pages/UserProfile/components/CinestarClub/saga'
import accountOrdersSaga from '../pages/UserProfile/components/TicketsAndReserv/saga'
import userProfileSaga from '../pages/UserProfile/saga'
import loadSnacksSaga from '../pages/YourOrder/components/AddSnackCoupon/saga'
import yourOrderSaga from '../pages/YourOrder/saga'
import tokenSaga from '../services/token/saga'
import userSaga from '../services/user/saga'

/**
 * Root generator for all application sagas
 * Place any saga you wish to run into the yield all array
 */
export default function* () {
    yield all([
        basketSaga(),
        changeForgottenPasswordSaga(),
        changePasswordSaga(),
        cinestarClubSaga(),
        contactInfoSaga(),
        forgottenPasswordSaga(),
        hallSaga(),
        hallSeatingSaga(),
        loginSaga(),
        lostCardSaga(),
        registerClubSaga(),
        registerSaga(),
        tokenSaga(),
        userProfileSaga(),
        yourOrderSaga(),
        orderSummarySaga(),
        paymentVerifySaga(),
        userSaga(),
        accountOrdersSaga(),
        loadSnacksSaga(),
        sendSmsSaga(),
        downloadSaga(),
        messagesListSaga(),
        restoreBookingSaga(),
    ])
}
